import React, { useState } from "react";
import axios from "../../api/axiosConfig";
import { Card, Form, Button, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

function UsuarioCrear() {
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState({
    nombre: "",
    correo: "",
    celular: "",
    rol: "",
    contrasena: "",
  });

  const [errores, setErrores] = useState({});
  const [loading, setLoading] = useState(false);

  const roles = ["ADMIN", "CAJERO", "MESERO", "COCINA","JUGOS"];

  // 🔹 Validar campos
  const validar = () => {
    const nuevos = {};
    if (usuario.nombre.trim().length < 3)
      nuevos.nombre = "El nombre debe tener al menos 3 caracteres.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(usuario.correo))
      nuevos.correo = "Correo electrónico inválido.";
    if (!/^[0-9]{10}$/.test(usuario.celular))
      nuevos.celular = "El número de celular debe tener 10 dígitos.";
    if (!usuario.rol) nuevos.rol = "Selecciona un rol.";
    if (usuario.contrasena.length < 6)
      nuevos.contrasena = "La contraseña debe tener al menos 6 caracteres.";
    setErrores(nuevos);
    return Object.keys(nuevos).length === 0;
  };

  // 🔹 Enviar al backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validar()) {
      toast.warning("⚠️ Corrige los errores antes de continuar");
      return;
    }

    setLoading(true);
    try {
      await axios.post("/usuarios/registro", usuario);
      toast.success("✅ Usuario registrado correctamente");
      setTimeout(() => navigate("/usuarios"), 1500);
    } catch (error) {
      console.error("Error al registrar usuario:", error);
      toast.error("❌ No se pudo registrar el usuario");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <ToastContainer position="top-right" autoClose={3000} />

      <Card className="shadow-sm">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h5 className="fw-bold text-primary">👤 Registrar Nuevo Usuario</h5>
          <Button variant="secondary" onClick={() => navigate("/usuarios")}>
            ⬅️ Volver
          </Button>
        </Card.Header>

        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Nombre completo</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ej: Juan Pérez"
                    value={usuario.nombre}
                    isInvalid={!!errores.nombre}
                    onChange={(e) =>
                      setUsuario({ ...usuario, nombre: e.target.value })
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {errores.nombre}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Correo electrónico</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Ej: juan@gmail.com"
                    value={usuario.correo}
                    isInvalid={!!errores.correo}
                    onChange={(e) =>
                      setUsuario({ ...usuario, correo: e.target.value })
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {errores.correo}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Celular</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ej: 3001234567"
                    value={usuario.celular}
                    isInvalid={!!errores.celular}
                    onChange={(e) =>
                      setUsuario({ ...usuario, celular: e.target.value })
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {errores.celular}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Rol</Form.Label>
                  <Form.Select
                    value={usuario.rol}
                    isInvalid={!!errores.rol}
                    onChange={(e) =>
                      setUsuario({ ...usuario, rol: e.target.value })
                    }
                  >
                    <option value="">Seleccionar rol</option>
                    {roles.map((r, i) => (
                      <option key={i} value={r}>
                        {r}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errores.rol}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Contraseña</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="********"
                    value={usuario.contrasena}
                    isInvalid={!!errores.contrasena}
                    onChange={(e) =>
                      setUsuario({ ...usuario, contrasena: e.target.value })
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {errores.contrasena}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <div className="text-end mt-4">
              <Button
                variant="success"
                type="submit"
                disabled={loading}
                className="px-4 fw-bold"
              >
                {loading ? "Guardando..." : "✅ Registrar Usuario"}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}

export default UsuarioCrear;
